<template>
  <div class="basis-full text-center sm:basis-6/12 lg:basis-4/12">
    <div
      class="te-bg-python-ai-banner-image relative h-full rounded bg-cover bg-center"
      style="flex: 1"
    >
      <TeCourseSetBannerBadgeTwo />
      <a
        class="co-bg-hover-trans-black-20 flex h-full text-center text-white hover:bg-co-gray-950/20 hover:text-white"
        href="/set/python-ai"
      >
        <div class="mx-auto p-4">
          <img
            class="mx-auto mb-3 md:mb-4"
            src="~/assets/images/Te/TeCourse/SetBanner/PythonAi/set-icon-python-ai.svg"
            loading="lazy"
            alt="PythonAIセット"
            width="94"
            height="49"
          >
          <h3
            class="co-display-11 mb-3 w-full font-bold tracking-[.15em]"
            style="line-height: 1.5"
          >
            Python<br>AIセット
          </h3>
          <p class="co-display-14 mb-2 border-b pb-3">
            Pythonを使ってAIの構築に必要な機械学習・ディープラーニング習得
          </p>
          <p class="co-display-13 tracking-[.15em]">
            申込締切
            <ClientOnly>
              <span class="co-display-9 pl-2 pr-1 font-bold">{{ closesMonth }}</span>月
              <span class="co-display-9 pr-1 font-bold">{{ closesDays }}</span>日（{{ closesDayOfWeek }}）{{ closesHours }}時
            </ClientOnly>
          </p>
        </div>
      </a>
    </div>
  </div>
</template>

<script lang="ts">
import { getPack } from '~/utility/fetchAPI'
import { dateToYesterday, daysOfWeek } from '~/utility/utility'
import TeCourseSetBannerBadgeTwo from '~/components/Te/TeCourse/SetBanner/Badge/TeCourseSetBannerBadgeTwo.vue'

/* eslint-disable camelcase */
interface Pack {
  attributes: {
    closes_at: string
    track_title: string
  }
}
/* eslint-enable */

interface Data {
  pack: Pack | null
}

interface Methods {}

interface Computed {
  closesAt: Date | null
  yesterdayClosesAt: Date | null
  closesDays: number | '-'
  closesMonth: number | '-'
  closesHours: number | '-'
  closesDayOfWeek: '日' | '月' | '火' | '水' | '木' | '金' | '土' | '-'
  trackTitles: string[]
}

interface Props {
  firstOpenedWholeCohort: any
  course: any
}

const options = {
  data() {
    return {
      pack: null,
    }
  },
  mounted() {
    getPack(this.$api, 'python-ai-set').then((response) => {
      this.pack = response.data
    })
  },
  computed: {
    closesAt() {
      if (!this.pack) {
        return null
      } else {
        return new Date(this.pack.attributes.closes_at)
      }
    },
    yesterdayClosesAt() {
      return this.closesAt ? dateToYesterday(this.closesAt) : null
    },
    closesDays() {
      return this.yesterdayClosesAt ? this.yesterdayClosesAt.getDate() : '-'
    },
    closesMonth() {
      return this.yesterdayClosesAt
        ? this.yesterdayClosesAt.getMonth() + 1
        : '-'
    },
    closesHours() {
      return this.yesterdayClosesAt
        ? this.yesterdayClosesAt.getHours() + 24
        : '-'
    },
    closesDayOfWeek() {
      return this.yesterdayClosesAt ? daysOfWeek(this.yesterdayClosesAt) : '-'
    },
    trackTitles() {
      return this.pack ? this.pack.attributes.track_title.split('+') : ['-']
    },
  },
  components: {
    TeCourseSetBannerBadgeTwo,
  },
}

export default defineComponent(options)
</script>

<style scoped>
.te-bg-python-ai-banner-image {
  background-image: url('~/assets/images/Te/TeCourse/SetBanner/PythonAi/python-ai-set-s.jpg');
}
</style>
